export enum FavoriteStatus {
  TRY_ME = 'TRY_ME',
  EATEN = 'EATEN',
  FAVORITE = 'FAVORITE',
  NOT_EATEN = 'NOT_EATEN'
}
